import { gql, useQuery } from '@apollo/client';

export const GET_QUESTIONNAIRES_BY_ID = gql`
  query getEmployeeQuestionnaireById($id: String!) {
    getEmployeeQuestionnaireById(id: $id) {
      _id
      questionnaireSettingsId
      companyId
      jobId
      jobLocationId
      jobCompanyId
      status
      responsiblePersonsIds
      employeePersonalInfo {
        firstName
        lastName
        email
        birthName
        countryOfBirth
        cityOfBirth
        salutation
        birthName
        personalEmail
        gender
        street
        country
        status
        accessToPlatform
        employeeNumber
        houseNumber
        city
        zipCode
        phoneNumber
        nationality
        birthday
        academicDegree
        socials {
          linkedIn
          xing
        }
      }
      paymentAndInsurance {
        bankAccountHolder
        iban
        bic
        typeOfVisa
        visaExpirationDate
        nationalInsuranceNumber
        healthInsuranceType
        healthInsuranceId
        taxId
        workPermissionNeeded
        hasCertificateOfStudy
        residencePermissionNeeded
        workPermissionExpireDate
        certificateOfStudyExpireDate
        residencePermissionExpireDate
        healthInsuranceCardName
      }
      emergencyContact {
        maritalStatus
        childAllowance
        name
        phoneNumber
        relationship
      }
      educationAndSkills {
        schoolName
        universityName
        furtherName
        driversLicenses
        trainingName
        highestTrainingDegree
        skills {
          name
          description
        }
      }
      finishInformation {
        privacyPolicyConfirmation
        accuracyConfirmation
        miniJobDocumentId
        miniJobDocumentClick
        exemptFromPensionFund
      }
      signatureId
      signature {
        filename
        location
      }
      healthInsuranceCard {
        filename
        location
      }
      personalIdCardFront {
        filename
        location
      }
      personalIdCardBack {
        filename
        location
      }
      questionnaireSettings {
        name
        _id
      }
      healthInsurance {
        name
        _id
      }
    }
  }
`;

export const useGetEmployeeQuestionnaireById = (id: string) => {
  const { data = {}, loading } = useQuery(GET_QUESTIONNAIRES_BY_ID, {
    variables: { id },
    skip: !id,
  });

  const employeeQuestionnaire = data?.getEmployeeQuestionnaireById || {};

  return { employeeQuestionnaire, loading };
};
